import { CheckboxProps } from 'antd/lib/checkbox';

import { StyledCheckbox } from './styles';

export function UiCheckbox(props: CheckboxProps) {
  return <StyledCheckbox {...props} />;
}
